import { useTranslation } from 'react-i18next'

import { FORMIK_SELECT_EMPTY_VALUE } from '../../../../../../constants/validation'
import { getItemsFromApiResponse } from '../../../../../../utils/api'
import {
  BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
  BuildingSelect,
} from '../../../../../Building'
import { FieldStackedLabel } from '../../../../../Field'
import { FormFieldSelectNG } from '../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'
import {
  REGISTRATION_FORM_FIELD_HEIGHT,
  REGISTRATION_FORM_FIELD_NAME_BUILDING,
} from '../../RegistrationForm.constants'
import { getOpenDataBuildings } from '../RegistrationFormFields.api'
import {
  getBuildingSelectSearchParam,
  toBuildingSelectItemsFromOpenData,
} from '../RegistrationFormFields.utils'

function BuildingField({ disabled, ukId, onClear }) {
  const { t } = useTranslation()

  const apiParams = {
    ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
    ukId,
  }

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={BuildingSelect}
      apiParams={apiParams}
      controlProps={{
        contentProps: {
          inputProps: {
            placeholder: t('Auth.SignUpBuildingPlaceholderKey'),
          },
        },
        height: REGISTRATION_FORM_FIELD_HEIGHT,
      }}
      disabled={disabled}
      emptyValue={FORMIK_SELECT_EMPTY_VALUE}
      fieldComponentProps={{
        label: t('Auth.SignUpBuildingLabelKey'),
      }}
      getData={getOpenDataBuildings}
      getDataItems={getItemsFromApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      getSearchApiParam={getBuildingSelectSearchParam}
      name={REGISTRATION_FORM_FIELD_NAME_BUILDING}
      toPreparedItems={toBuildingSelectItemsFromOpenData}
      onClear={onClear}
    />
  )
}

export default BuildingField
